<script>
import { defineComponent, inject, computed } from "vue"
import "@css/index.css"
import { navAndFooter } from "@project/api/nav-and-footer/v1";
import Column from "@kit/components/Column.vue"

export default defineComponent({
  name: "Footer",
  setup() {
    const hydrate = inject('hydrate')

    const { prefetch } = hydrate({
      prefetch:["navAndFooter"]
    })

    const navAndFooter = computed(() => {
      return prefetch.value && prefetch.value.navAndFooter ? prefetch.value.navAndFooter : null
    })

    return { navAndFooter };
  },
  components: {
    Column
  },
});

</script>

<style>
  .footer {
    background-color: var(--dark-blue);
    color:white !important;
    font-size:1.2rem;
  }
  .footer-element-1 {
    width:200px !important;
  }
  .footer-element-2 {
    width:460px !important;
  }
  @media (max-width:960px) {
    .footer-element-1 {
      width:100px !important;
    }
    .footer-element-2 {
      width:200px !important;
      font-size:1.2rem;
    }
  }
  @media (max-width:600px) {
    .footer-element-1 {
      width:100px !important;
    }
    .footer-element-2 {
      width:200px !important;
      font-size:1.2rem;
    }
  }
</style>

<template>
  <footer class="footer sb sb-v" style="z-index:4;">
  
    <Column v-if="navAndFooter" ltD="70" ltT="80" ltP="90" ltS="98" gtB="700" gtH="700" class="sb sb-v sb-g20" tag="div">
      <div class="sb sb-v" v-html="navAndFooter.footer_html"></div>
    </Column>
  
  </footer>



  <!-- <footer class="sb sb-v sb-g20" v-if="navAndFooter && okToShow">
    <div class="sb sb-h sb-ltm-h2v sb-uniform-3" style="z-index:3">
      <div class="sb sb-v sb-uniform" v-html="navAndFooter.footer_column_1">
      </div>
      <div class="sb sb-v sb-uniform" v-html="navAndFooter.footer_column_2">
      </div>
      <div class="sb sb-v sb-uniform" v-html="navAndFooter.footer_column_3">
      </div>
    </div>
    <div class="sb sb-h sb-align-ch" style="z-index:2">
      <p class="sb sb-text">© 2025 Humboldt Transit | Site Credits</p>
    </div>
    <img :class="navAndFooter.footer_background_image_classes"
      :style="`z-index:1; ${navAndFooter.footer_background_image_style}`" 
      :alt="navAndFooter.footer_background_image_aria" 
      :src="navAndFooter.footer_background_image.guid">
  </footer>
  <footer v-else></footer> -->
</template>